import React from 'react';
import styles from './RolePill.module.css';

interface RolePillProps {
  role: 'BA' | 'WA' | 'SC';
}

export const RolePill: React.FC<RolePillProps> = ({ role }) => {
  return <span className={styles.pill}>{role}</span>;
};
